import { useEffect, useState } from 'react';
import avtr from '../media/user.png';

import { GetAuthUser } from '../services/user-accounts';

const list = require('../data/data-user-tasks.json').data;

export default function UserTasksListModule() {

  const asset = GetAuthUser();

  const [loading,setLoading]=useState(false);
  const [data,setData]=useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        setLoading(true);
        setData(list);
        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  if (loading)
  return (<><p className="text-muted small">Please Wait...</p> </>)

  if (data.length===0)
  return (<><p className="text-muted small">No Records</p> </>)

  return (
    <>
    <div className="card rounded-wd border bg-white">

      {data && data.map((item, i) => (
        <div className="d-flex p-3 border-bottom" key={i}>

          <div className="me-auto">
            <p className="fw-bold m-0 p-0">{item.name}, {item.scor} PTS</p>
            <p className="small m-0 p-0">{item.task}</p>
          </div>
        
          <div className="text-end" style={{width:'fit-content'}}>
            <button className="btn btn-sm btn-outline-primary rounded-pill px-4 py-2">
              <small>Submit</small>
            </button>
          </div>
        </div>
      ))}
    </div>

    </>
  )
}